import { toast } from '@/common/util'
import baseApi from './base.api'
import type { ParamsRules } from '@/types/types'

const api = {
  ...baseApi,
  resource: 'Desafio',
  async getRules(params: ParamsRules): Promise<{success: boolean, data: {regra: string, descricao: string}[]}> {
    try {
      return await api.get('Regra', {ambiente: params.environment})
    } catch (error) {
      const { notifications }: { notifications: string[] } = error.response?.data || {}
      toast.error({message: notifications[0] || 'Erro ao tentar buscar regras!'})
    }
  },

  async associationsContent(params: {challengeId: string, type: string, contentIds: string[]}) {
    try {
      return await api.put(`${params.challengeId}/UpdateDesafioCursosFormacoes/${params.type}`, params.contentIds)
    } catch (error) {
      const { notifications }: { notifications: string[] } = error.response?.data || {}
      toast.error({message: notifications[0] || 'Erro ao associar conteúdos ao desafio!'})
    }
  }
}

export default api
